exports = module.exports = require("../../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CreateNewWorkspace__Textarea__28Z87 {\n  display: block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  resize: none;\n  overflow: auto;\n\n  font-size: 16px;\n  padding: 6px 8px;\n\n  border: 1px solid rgb(226, 226, 226);\n  border-radius: 4px;\n  color: #000;\n  background: transparent;\n}\n\n.CreateNewWorkspace__Textarea__28Z87:hover {\n  border-color: rgb(194, 194, 194);\n}\n\n.CreateNewWorkspace__Textarea__28Z87:focus {\n  color: #35383a;\n  background-color: #fff !important;\n  border-color: rgb(17, 100, 224);\n  outline: none;\n}\n", ""]);

// exports
exports.locals = {
	"Textarea": "CreateNewWorkspace__Textarea__28Z87"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskPage/WorkspaceView/CreateNewWorkspace/CreateNewWorkspace.css
// module id = 799
// module chunks = 0